import React, { useMemo } from 'react';
import { companyStats, aboutMenuItems } from '../data/mockData';
import { Building, Users, Award, Globe } from 'lucide-react';

const BiziTaniyin = () => {
  const highlights = [
    {
      icon: Building,
      title: '1996',
      description: 'Kuruluş Yılı'
    },
    {
      icon: Users,
      title: '120+',
      description: 'Yıl Tecrübe'
    },
    {
      icon: Award,
      title: 'TurkishBank',
      description: 'Group İştiraki'
    },
    {
      icon: Globe,
      title: '3 Ülke',
      description: 'Faaliyet Gösteriyoruz'
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <div className="relative h-96 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 flex items-center">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.02) 35px, rgba(255,255,255,.02) 70px)'
          }}></div>
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <h1 className="text-6xl font-bold text-white mb-4">Bizi Tanıyın</h1>
          <p className="text-slate-300 text-xl max-w-2xl">120 yılı aşkın tecrübesiyle sermaye piyasalarında güvenilir çözüm ortağınız</p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          {/* About Text */}
          <div className="bg-white rounded-xl shadow-lg p-8 mb-12">
            <div className="prose prose-lg max-w-none text-slate-700 space-y-4">
              <p>
                Türkiye, Kıbrıs ve İngiltere'de olmak üzere 3 ülkede bankacılık faaliyeti gösteren TurkishBank Group iştiraki Turkish Menkul Değerler, 31 Aralık 1996 tarihinde kurulmuştur.
              </p>
              <p>
                120 yılı aşkın tecrübesi ile sermaye piyasalarında müşterilerine hizmet vermekte olan Turkish Menkul Değerler, 141.800.000 TL ödenmiş sermayeye sahiptir.
              </p>
              <p>
                Turkish Menkul Değerler'in, TurkishBank ve Kıbrıs'ta bulunan TürkBankası ile acentelik ilişkisi bulunmaktadır. Turkish Menkul Değerler, Genel Müdürlüğünün yanı sıra 4 şubesi ile hizmet vermektedir.
              </p>
            </div>
          </div>

          {/* Highlights */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
            {highlights.map((item) => (
              <div key={item.title} className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-6 text-center">
                <div className="bg-orange-500 w-12 h-12 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <item.icon className="w-6 h-6 text-white" />
                </div>
                <div className="text-2xl font-bold text-orange-600 mb-1">{item.title}</div>
                <div className="text-sm text-slate-600">{item.description}</div>
              </div>
            ))}
          </div>

          {/* Stats */}
          <div className="bg-gradient-to-r from-slate-900 to-slate-800 rounded-xl p-12 mb-12">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              {companyStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-5xl font-bold text-orange-400 mb-2">{stat.value}</div>
                  <div className="text-slate-300 text-sm">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation to other about pages */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {useMemo(() => aboutMenuItems.filter(item => item.name !== 'Bizi Tanıyın'), []).map((item) => (
              <a
                key={item.link}
                href={item.link}
                className="bg-slate-50 hover:bg-orange-50 border-2 border-slate-200 hover:border-orange-500 rounded-xl p-6 transition-all group"
              >
                <h3 className="text-lg font-semibold text-slate-900 group-hover:text-orange-600 transition-colors">
                  {item.name}
                </h3>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BiziTaniyin;